module.exports = __webpack_public_path__ + "images/werbefilm/werbefilm_logo.png";